import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D1D2B0DA-2EAD-451B-A9D9-B4C52E16FEDC
 * name arrow-top-left-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftThickIcon = createSvgIcon(<><path d="M9.12,11.94V16.89H5.69V5.69H16.89V9.12H11.94L18.31,15.5L15.5,18.31L9.12,11.94Z" /></>, 'ArrowTopLeftThickIcon');
export default ArrowTopLeftThickIcon